<template>
    <!-- 学情信息 -->
    <div>
        <div class="conditionSearchBox">
            <div class="conditionItem">
                <el-date-picker v-model="date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
                </el-date-picker>
            </div>
            <div class="conditionItem">
                <el-select v-model="params.condition.checkstatus" placeholder="考勤状态" clearable>
                    <el-option v-for="item in checkstatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.classname" placeholder="班级名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.classcoursename" placeholder="课程名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.periodname" placeholder="课时名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
                <el-button type="" icon="el-icon-refresh" @click="reset">重置</el-button>
            </div>
        </div>
        <el-table :data="tableData" border class="table-fixed-col" v-loading="contentLoading" ref="table">
            <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                <template slot-scope="scope">
                    <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                </template>
            </el-table-column>
            <el-table-column prop="classname" label="班级名称" align="center" min-width="200" key="classname" fixed show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="classcoursename" label="课程名称" align="center" width="150" key="classcoursename" show-overflow-tooltip></el-table-column>
            <el-table-column prop="score" label="课时时间" align="center" width="250" key="score">
                <template slot-scope="scope">
                    <p>{{scope.row.periodtime + '~' + scope.row.periodtimeend}}</p>
                </template>
            </el-table-column>
            <el-table-column v-if="periodstatus === 30" prop="checkstatusname" label="课时状态" align="center" width="100" key="checkstatusname"></el-table-column>
            <el-table-column v-if="periodstatus === 30" prop="checktime" label="打卡时间" align="center" width="200" key="checktime"></el-table-column>

            <el-table-column v-if="periodstatus === 10" prop="teachername" label="上课老师" align="center" min-width="200" key="teachername" show-overflow-tooltip></el-table-column>
            <el-table-column v-if="periodstatus === 10" prop="content" label="上课内容" align="center" min-width="200" key="content" show-overflow-tooltip :formatter="formatTab"></el-table-column>
        </el-table>
        <Page v-if="total > 0" @pageChange="pageChange" @pagesizeChange="pagesizeChange" :total="total" :page="params.page" :pagesize="params.pagesize" />
    </div>
</template>
<script>
import { getTableDefaultPageSize } from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Page from '@/components/measComponents/page/page.vue'
import { getStudyDetailsByStatus } from '@/api/measApi/studentManage.js'
export default {
  data() {
    return {
      params: {
        condition: {
          checkstatus: '',
          classcoursecode: '',
          classcoursename: '',
          classname: '',
          code: '',
          periodstatus: '',
          periodtimeend: '',
          periodtimestart: '',
          studentcode: '',
          studentname: '',
          periodname: ''
        },
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      contentLoading: false,
      tableData: [],
      total: 0,
      isSelect: false,
      date: [],
      //   考勤状态
      checkstatusList: [
        {
          value: 0,
          label: '未到'
        },
        {
          value: 10,
          label: '到课'
        },
        {
          value: '11',
          label: '请假'
        }
      ]
    }
  },
  props: {
    code: {
      type: String,
      required: true
    },
    periodstatus: {
      type: Number,
      required: true
    },
    classCode: {
      type: String
    }
  },
  components: {
    TableSort,
    Page
  },
  created() {
    this.params.condition.studentcode = this.code
    this.params.condition.periodstatus = this.periodstatus
    this.params.condition.code = this.classCode || ''
    this.$nextTick(() => {
      this.getStudyDetailsByStatus()
    })
  },
  methods: {
    //   获取班级列表
    getStudyDetailsByStatus() {
      this.contentLoading = true
      if (this.date && this.date.length > 0) {
        this.params.condition.periodtimestart = this.date[0]
        this.params.condition.periodtimeend = this.date[1]
      } else {
        this.params.condition.periodtimeend = ''
        this.params.condition.periodtimestart = ''
      }
      getStudyDetailsByStatus(this.params).then(res => {
        if (res.code === '000') {
          this.tableData = res.data
          this.total = res.pageinfo.rowcount
          this.contentLoading = false
        }
      })
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getStudyDetailsByStatus()
    },
    // 重置
    reset() {
      this.date = []
      this.params = {
        condition: {
          checkstatus: '',
          classcoursecode: '',
          classcoursename: '',
          classname: '',
          code: '',
          periodstatus: this.periodstatus,
          periodtimeend: '',
          periodtimestart: '',
          studentcode: this.code,
          studentname: '',
          periodname: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      }
      this.getStudyDetailsByStatus()
    },
    // 分页
    pageChange(page) {
      this.params.page = page
      this.getStudyDetailsByStatus()
    },
    pagesizeChange(size) {
      this.params.page = 1
      this.params.pagesize = size
      this.getStudyDetailsByStatus()
    },
    // 初始化表格
    formatTab(row, column, value) {
      return value ? value : '--'
    }
  }
}
</script>
